import { RouteRecordRaw } from 'vue-router'

const crewListsRoutes: RouteRecordRaw[] = [
  {
    path: '/crew/crew-lists',
    name: 'crew-lists.index',
    component: () => import('@/modules/crewing/views/crew-lists/CrewListsIndex.vue'),
    meta: {
      pageTitle: 'Crew lists',
      breadcrumbs: ['Crew lists']
    }
  },
  {
    path: '/crew/crew-lists/:id',
    name: 'crew-lists.show',
    component: () => import('@/modules/crewing/views/crew-lists/CrewListShow.vue'),
    meta: {
      pageTitle: 'Crew list',
      breadcrumbs: ['Crew lists', 'Crew list']
    }
  }
]

export default crewListsRoutes
